// | ------------------------------------------------------------------------
// | Components - Fixed Header
// | ------------------------------------------------------------------------

var header = document.querySelector(".site-header");

let isHeaderEnabled = true; // Flag to control header functionality

// Function to enable or disable the header functionality
function toggleHeader(enable) {
  isHeaderEnabled = enable;
}

// Example usage:
// toggleHeader(false); // Disable header functionality
// toggleHeader(true);  // Enable header functionality

export {toggleHeader};

if (header) {
  let actualScroll = 200;
  
  var fixHeader = function () {
    if (!isHeaderEnabled){
      var top = header.clientHeight * -1;

      // Round up to the nearest pixel
      const roundedTop = Math.ceil(top);

      header.setAttribute("style", `--_top:${roundedTop}px`);
      header.classList.remove("active" ,"clr");

    }else{

      const top = Math.min(
        -(window.scrollY - actualScroll + header.clientHeight),
        0
      );

      if (window.scrollY > actualScroll) {
        actualScroll = window.scrollY;
      }

      if (top === 0) {
        actualScroll = window.scrollY + header.clientHeight;
      }

      // Round up to the nearest pixel
      const roundedTop = Math.ceil(top);

      header.setAttribute("style", `--_top:${roundedTop}px`);
      header.classList.toggle("active", window.scrollY < actualScroll);
      header.classList.toggle("clr", window.scrollY > header.clientHeight * 1.5);
    }
  };

  // Run on scroll/load/resize
  window.addEventListener("scroll", fixHeader, false);
  window.addEventListener("load", fixHeader, false);
  window.addEventListener("resize", fixHeader, false);

}

